$(document).ready(function () {
  // Large Slider
  // Loop over each instance of .wf-large-slider for multi slider on 1 page
  $(".wf-large-slider").each(function () {
    var $sliderInstance = $(this);
    var container = $sliderInstance.find(".slider-container");
    var tabHeadings = $sliderInstance.find(".tab-heading");
    var arrowContainer = $sliderInstance.find(".arrow-container");

    var productOptions = {
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: true,
            centerPadding: "0px",
            appendDots: arrowContainer,
          },
        },
      ],
    };

    function adjustSlideHeights() {
      var $slides = container.find('.slick-slide').not('.slick-cloned');
      if ($(window).width() > 1200) {
        var maxHeight = 0;
        $slides.css('height', 'auto');
        $slides.each(function () {
          var slideHeight = $(this).outerHeight();
          if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
          }
        });
        $slides.css('height', maxHeight + 'px');
      } else {
        $slides.css('height', 'auto');
      }
    }

    container.on('init', function () {
      adjustSlideHeights();
    });

    $(window).on('resize', function () {
      adjustSlideHeights();
    });

    container.slick(productOptions);

    container.on("setPosition", function () {
      adjustSlideHeights();
      arrowContainer.find(".prev-slide").remove();
      arrowContainer.find(".next-slide").remove();

      var prevButton = $(
        '<button class="prev-slide" aria-label="Previous" type="button" aria-disabled="false"><svg class="small-arrow" xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><path d="M7.63604 13.728L1.27208 7.36401L7.63604 1.00005" stroke="#B003D3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><svg class="large-arrow" width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.5" transform="matrix(-1 0 0 1 86 0)" fill="white" stroke="#B003D3" stroke-width="3"/><path d="M50.5883 43H36.9294" stroke="#290350" stroke-width="2" stroke-linecap="round"/><path d="M43.0255 36.853L36.9294 42.949L43.0255 49.045" stroke="#290350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sr-only">Previous Slide</span></button>'
      );
      var nextButton = $(
        '<button class="next-slide" aria-label="Next" type="button" aria-disabled="false"><svg class="small-arrow" xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><path d="M1.36396 1.00005L7.72792 7.36401L1.36396 13.728" stroke="#B003D3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><svg class="large-arrow" width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.5" transform="matrix(-1 0 0 1 86 0)" fill="white" stroke="#B003D3" stroke-width="3"/><path d="M35.4117 43H49.0706" stroke="#290350" stroke-width="2" stroke-linecap="round"/><path d="M42.9745 36.853L49.0705 42.949L42.9745 49.045" stroke="#290350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sr-only">Next Slide</span></button>'
      );

      if (container.slick("slickCurrentSlide") === 0) {
        prevButton.attr("aria-disabled", true).addClass("disabled");
      }

      if (
        container.slick("slickCurrentSlide") ===
        container.slick("getSlick").slideCount - 1
      ) {
        nextButton.attr("aria-disabled", true).addClass("disabled");
      }

      arrowContainer.append(prevButton);
      arrowContainer.append(nextButton);

      arrowContainer.find(".prev-slide").click(function () {
        if (!$(this).hasClass("disabled")) {
          container.slick("slickPrev");
        }
      });

      arrowContainer.find(".next-slide").click(function () {
        if (!$(this).hasClass("disabled")) {
          container.slick("slickNext");
        }
      });
    });

    container.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        var prevButton = arrowContainer.find(".prev-slide");
        var nextButton = arrowContainer.find(".next-slide");

        if (nextSlide === 0) {
          prevButton.attr("aria-disabled", true).addClass("disabled");
        } else {
          prevButton.attr("aria-disabled", false).removeClass("disabled");
        }

        if (nextSlide === slick.slideCount - 1) {
          nextButton.attr("aria-disabled", true).addClass("disabled");
        } else {
          nextButton.attr("aria-disabled", false).removeClass("disabled");
        }

        tabHeadings.removeClass("active");
        $(tabHeadings[nextSlide]).addClass("active");
      }
    );

    tabHeadings.on("click", function () {
      var slideIndex = $(this).data("slide");
      container.slick("slickGoTo", slideIndex);
      tabHeadings.removeClass("active");
      $(this).addClass("active");
    });

    container.on("afterChange", function (event, slick, currentSlide) {
      tabHeadings.removeClass("active");
      $(tabHeadings[currentSlide]).addClass("active");
    });
  });

  // Speed Cards Slider
  initSpeedCardSlider();

  // product cards slider

  //generic-product-cards-carousel
  var productSlider = $(".generic-product-cards-carousel");

  var productOptions = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 2,
          arrows: true,
          slidesToScroll: 1,
          dots: true,
          centerMode: false,
          variableWidth: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          dots: true,
          centerMode: true,
          centerPadding: "5px",
          variableWidth: true,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          dots: true,
          centerMode: true,
          centerPadding: "50px",
          variableWidth: false,
        },
      },
    ],
  };

  productSlider.slick(productOptions);

  productSlider.on("setPosition", function () {
    $(".wf-product-cards:not(.shop-fiber) .arrow-container")
      .find(".prev-slide")
      .remove();
    $(".wf-product-cards:not(.shop-fiber) .arrow-container")
      .find(".next-slide")
      .remove();

    prevButton = $(
      '<button class="prev-slide" aria-label="Previous" type="button" aria-disabled="false"><svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.5" transform="matrix(-1 0 0 1 86 0)" fill="white" stroke="#B003D3" stroke-width="3"/><path d="M50.5883 43H36.9294" stroke="#290350" stroke-width="2" stroke-linecap="round"/><path d="M43.0255 36.853L36.9294 42.949L43.0255 49.045" stroke="#290350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sr-only">Previous Slide</span></button>'
    );
    nextButton = $(
      '<button class="next-slide" aria-label="Next" type="button" aria-disabled="false"><svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.5" transform="matrix(-1 0 0 1 86 0)" fill="white" stroke="#B003D3" stroke-width="3"/><path d="M35.4117 43H49.0706" stroke="#290350" stroke-width="2" stroke-linecap="round"/><path d="M42.9745 36.853L49.0705 42.949L42.9745 49.045" stroke="#290350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sr-only">Next Slide</span></button>'
    );
    $(".wf-product-cards:not(.shop-fiber) .arrow-container").append(prevButton);
    $(".wf-product-cards:not(.shop-fiber) .arrow-container").append(nextButton);

    var currentSlide = productSlider.slick("slickCurrentSlide");
    var totalSlides = productSlider.slick("getSlick").slideCount;
    var slidesToShow = productSlider.slick("slickGetOption", "slidesToShow");

    if (currentSlide === 0) {
      prevButton.attr("aria-disabled", true).addClass("disabled");
    }
    if (currentSlide >= totalSlides - slidesToShow) {
      nextButton.attr("aria-disabled", true).addClass("disabled");
    }

    $(".wf-product-cards:not(.shop-fiber) .arrow-container")
      .find(".prev-slide")
      .click(function () {
        productSlider.slick("slickPrev");
      });

    $(".wf-product-cards:not(.shop-fiber) .arrow-container")
      .find(".next-slide")
      .click(function () {
        productSlider.slick("slickNext");
      });
  });

  productSlider.on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var prevButton = $(
        ".wf-product-cards:not(.shop-fiber) .arrow-container .prev-slide"
      );
      var nextButton = $(
        ".wf-product-cards:not(.shop-fiber) .arrow-container .next-slide"
      );

      if (nextSlide === 0) {
        prevButton.attr("aria-disabled", true).addClass("disabled");
      } else {
        prevButton.attr("aria-disabled", false).removeClass("disabled");
      }

      if (nextSlide === slick.slideCount - 1) {
        nextButton.attr("aria-disabled", true).addClass("disabled");
      } else {
        nextButton.attr("aria-disabled", false).removeClass("disabled");
      }
    }
  );

  var productTabHeadings = $(
    ".wf-product-cards:not(.shop-fiber) .tab-headings .tab-heading"
  );
  productTabHeadings.on("click", function () {
    var slideIndex = $(this).data("slide");
    productSlider.slick("slickGoTo", slideIndex);
    productTabHeadings.removeClass("active");
    $(this).addClass("active");
  });

  // Update tab heading state on slider change
  productSlider.on("afterChange", function (event, slick, currentSlide) {
    productTabHeadings.removeClass("active");
    $(productTabHeadings[currentSlide]).addClass("active");
  });

  // Initialize tab headings
  $(productTabHeadings[productSlider.slick("slickCurrentSlide")]).addClass(
    "active"
  );

  // Testimonial Slider

  var testimonialSlider = $(".wf-lumos-testimonials .testimonial-carousel");
  //if at least 3 slides
  var slideCount = testimonialSlider.find(".testimonial-item-container").length;
  var showDots = false;

  // Restrict to 3 per slider page
  if (slideCount > 3) {
    slideCount = 3;
    showDots = true;
  }

  testimonialSlider.slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    appendDots: $(".wf-lumos-testimonials .testimonial-dots"),
    nextArrow: $(".wf-lumos-testimonials .arrow-container .next-slide"),
    prevArrow: $(".wf-lumos-testimonials .arrow-container .prev-slide"),
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          arrows: true,
          slidesToScroll: 1,
          dots: false,
          centerMode: false,
          variableWidth: false,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          dots: false,
          centerMode: true,
          centerPadding: "5px",
          variableWidth: true,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          dots: false,
          centerMode: true,
          centerPadding: "10px",
          variableWidth: false,
        },
      },
    ],
  });
  // Change the ID of testimonial's slider div
  $(".testimonial-item-container").each(function () {
    // Get the value of 'aria-describedby' attribute
    var ariaDescribedBy = $(this).attr("aria-describedby");
    $(this).attr("id", ariaDescribedBy);
  });

  $(".quote-slider").each(function () {
    $(this).slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
    });

    $(this)
      .find(".slick-prev, .slick-next")
      .appendTo($(this).find(".slick-dots"));
  });
});

function initSpeedCardSlider() {
  // Speed Cards Slider

  var speedSlider = $(
    ".speed-cards-carousel:not(.fieldset-container):not(.no-slider)"
  );
  var tabHeadings = $(
    ".wf-speed-cards:not(.shop-fiber):not(.no-slider) .tab-headings .tab-heading"
  );
  var previousWidth = $(window).width();
  var hasBusinessCards = $(".wf-speed-cards").hasClass("business-cards");
  var onlyMobile = speedSlider.hasClass("only-mobile-slider");
  var sameHeight = speedSlider
    .parents(".wf-speed-cards")
    .hasClass("same-height");
  var mobileBreak = 992;

  function reinitializeCardSlider() {
    var slidesToShow = speedSlider.slick("slickGetOption", "slidesToShow");
    var totalSlides = speedSlider.slick("getSlick").slideCount;

    productOptions.initialSlide == hasBusinessCards
      ? 0
      : productOptions.initialSlide;

    if (slidesToShow === totalSlides) {
      productOptions.initialSlide = 0;
      speedSlider.slick("unslick");
      speedSlider.slick(productOptions);
    } else if (onlyMobile && $(window).width() >= mobileBreak) {
      console.log("unslick mobile slider");
      speedSlider.slick("unslick");
    } else {
      speedSlider.slick("refresh");
    }

    if ((onlyMobile && $(window).width() < mobileBreak) || sameHeight) {
      function setEqualHeight() {
        var maxHeight = 0;
        // Reset all heights to auto before finding the max height
        $(".slick-track .card").css("height", "auto");

        $(".slick-track .card").each(function () {
          var thisHeight = $(this).height();
          if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
          }
        });
        $(".slick-track .card").height(maxHeight);
      }

      setEqualHeight();
    }
  }

  //watch for resize to apply correct slide
  var previousWidth = $(window).width();
  $(window).resize(function () {
    var slidesToShow = speedSlider.slick("slickGetOption", "slidesToShow");
    var totalSlides = speedSlider.slick("getSlick").slideCount;
    // not if all slides are in view
    if (totalSlides === slidesToShow) {
      return;
    }

    var currentWidth = $(window).width();
    var currentSlide = speedSlider.slick("slickCurrentSlide");

    if (
      (previousWidth > 1250 && currentWidth <= 1250) ||
      (previousWidth > 992 && currentWidth <= 992)
    ) {
      speedSlider.slick("slickGoTo", currentSlide);
    } else if (
      (previousWidth <= 1250 && currentWidth > 1250) ||
      (previousWidth <= 992 && currentWidth > 992)
    ) {
      if (currentWidth > 1250 && currentSlide == 1) {
        speedSlider.slick("slickGoTo", 1);
      } else {
        speedSlider.slick("slickGoTo", currentSlide);
      }
    }

    previousWidth = currentWidth;
    reinitializeCardSlider();
  });

  var productOptions = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    initialSlide: hasBusinessCards ? 0 : 0,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 2,
          arrows: true,
          slidesToScroll: 1,
          dots: true,
          centerMode: false,
          variableWidth: false,
          initialSlide: hasBusinessCards ? 0 : 0,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          dots: true,
          centerMode: true,
          centerPadding: "5px",
          variableWidth: true,
          initialSlide: hasBusinessCards ? 0 : 1,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          dots: true,
          centerMode: true,
          centerPadding: "50px",
          variableWidth: false,
          initialSlide: hasBusinessCards ? 0 : 1,
        },
      },
    ],
  };

  productOptions.initialSlide == hasBusinessCards
    ? 0
    : productOptions.initialSlide;

  speedSlider.slick(productOptions);
  reinitializeCardSlider();

  speedSlider.on("setPosition", function () {
    $(".wf-speed-cards:not(.shop-fiber) .arrow-container")
      .find(".prev-slide")
      .remove();
    $(".wf-speed-cards:not(.shop-fiber) .arrow-container")
      .find(".next-slide")
      .remove();

    prevButton = $(
      '<button class="prev-slide" aria-label="Previous" type="button" aria-disabled="false"><svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.5" transform="matrix(-1 0 0 1 86 0)" fill="white" stroke="#B003D3" stroke-width="3"/><path d="M50.5883 43H36.9294" stroke="#290350" stroke-width="2" stroke-linecap="round"/><path d="M43.0255 36.853L36.9294 42.949L43.0255 49.045" stroke="#290350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sr-only">Previous Slide</span></button>'
    );
    nextButton = $(
      '<button class="next-slide" aria-label="Next" type="button" aria-disabled="false"><svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.5" transform="matrix(-1 0 0 1 86 0)" fill="white" stroke="#B003D3" stroke-width="3"/><path d="M35.4117 43H49.0706" stroke="#290350" stroke-width="2" stroke-linecap="round"/><path d="M42.9745 36.853L49.0705 42.949L42.9745 49.045" stroke="#290350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="sr-only">Next Slide</span></button>'
    );
    $(".wf-speed-cards:not(.shop-fiber) .arrow-container").append(prevButton);
    $(".wf-speed-cards:not(.shop-fiber) .arrow-container").append(nextButton);

    var currentSlide = speedSlider.slick("slickCurrentSlide");
    var totalSlides = speedSlider.slick("getSlick").slideCount;
    var slidesToShow = speedSlider.slick("slickGetOption", "slidesToShow");

    if (currentSlide === 0) {
      prevButton.attr("aria-disabled", true).addClass("disabled");
    }
    if (currentSlide >= totalSlides - slidesToShow) {
      nextButton.attr("aria-disabled", true).addClass("disabled");
    }

    if (slidesToShow == totalSlides) {
    }

    $(".wf-speed-cards:not(.shop-fiber) .arrow-container")
      .find(".prev-slide")
      .click(function () {
        speedSlider.slick("slickPrev");
      });

    $(".wf-speed-cards:not(.shop-fiber) .arrow-container")
      .find(".next-slide")
      .click(function () {
        speedSlider.slick("slickNext");
      });
  });

  speedSlider.on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var prevButton = $(
        ".wf-speed-cards:not(.shop-fiber) .arrow-container .prev-slide"
      );
      var nextButton = $(
        ".wf-speed-cards:not(.shop-fiber) .arrow-container .next-slide"
      );

      if (nextSlide === 0) {
        prevButton.attr("aria-disabled", true).addClass("disabled");
      } else {
        prevButton.attr("aria-disabled", false).removeClass("disabled");
      }

      if (nextSlide === slick.slideCount - 1) {
        nextButton.attr("aria-disabled", true).addClass("disabled");
      } else {
        nextButton.attr("aria-disabled", false).removeClass("disabled");
      }

      tabHeadings.removeClass("active");
      $(tabHeadings[nextSlide]).addClass("active");
    }
  );

  tabHeadings.on("click", function () {
    var slideIndex = $(this).data("slide");
    speedSlider.slick("slickGoTo", slideIndex);
    tabHeadings.removeClass("active");
    $(this).addClass("active");
  });

  tabHeadings.eq(speedSlider.slick("slickCurrentSlide")).click();

  speedSlider.on("afterChange", function (event, slick, currentSlide) {
    tabHeadings.removeClass("active");
    $(tabHeadings[currentSlide]).addClass("active");
  });

  if (typeof setSpeedSliderDropdowns === "function") {
    setSpeedSliderDropdowns();
  }
}
